<template>
  <div
    class="flash flash--success flash--close"
    role="alert"
    @click="$emit('close')"
  >
    <strong v-html="notification.title" />
    <span v-html="notification.text" />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'Success',
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
}
</script>
